import { Center } from "@chakra-ui/react";
import styled from "@emotion/styled";

export const CalendarWrapper = styled(Center)`
    width: 904px;
    height: 504px;

    @media (max-width: ${({ theme }) => theme.MEDIA.mobile}) {
        width: 320px;
        height: auto;
        align-items: flex-start;
        padding: 32px 0;
        overflow: auto;
    }
`;
